import { withScreen as withScreenOrigin } from '@gogame/screens';

import { screenReducerWithAnalyticsAdapter } from './screenReducerWithAnalyticsAdapter';
import { screenWithAnalyticsAdapter } from './screenWithAnalyticsAdapter';

export const withScreen =
  ({ businessKeyQuery, reducer, ...config }) =>
  (BaseComponent) =>
    withScreenOrigin({
      reducer: screenReducerWithAnalyticsAdapter(reducer),
      ...config,
    })(
      screenWithAnalyticsAdapter(
        { businessKeyQuery, name: config.name },
        BaseComponent
      )
    );
